import React from 'react'
import { Alert, Row } from 'reactstrap'
import AutoTable from 'components/AutoTable'
import { NetSuiteAssetProduct } from 'types'

interface ProductGridProps {
  products: NetSuiteAssetProduct[]
}

const ProductGrid: React.FC<ProductGridProps> = ({ products }) => {
  const columns = [
    {
      title: 'SKU',
      fieldValue: 'skuValue',
    },
    {
      title: 'Program Codes',
      fieldValue: (product: NetSuiteAssetProduct) => {
        return product.programCodes.join(', ')
      },
    },
    {
      title: 'Description',
      fieldValue: 'description',
    },
  ]

  return products.length ? (
    <Row>
      <AutoTable
        borderless
        columns={columns}
        filter
        headThemeLight
        rows={products}
        sort
      />
    </Row>
  ) : (
    <Alert color="warning">No products found</Alert>
  )
}

export default ProductGrid
